module.exports = __webpack_public_path__ + "img/sign_230120652_1.262e85b2.png";